/* Storefront-only Birthday Sale collection ordering. */
(() => {
  const hasActiveFiltersOrSort = () => [...new URLSearchParams(window.location.search).keys()]
    .some((key) => key.startsWith('filter.') || key === 'sort_by');

  const sortSaleProducts = (grid) => {
    const productItems = [...grid.querySelectorAll(':scope > .js-pagination-result')]
      .filter((item) => item.querySelector('product-card'));
    productItems
      .sort((a, b) => Number(b.querySelector('.card--birthday-sale') !== null) - Number(a.querySelector('.card--birthday-sale') !== null))
      .forEach((item) => grid.append(item));
  };

  const fetchPageProducts = async (url) => {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Collection page ${response.status}`);

    const documentFragment = document.createElement('template');
    documentFragment.innerHTML = await response.text();
    const page = documentFragment.content.querySelector('custom-pagination');
    const pageGrid = page?.querySelector('#filter-results ul');
    if (!page || !pageGrid) throw new Error('Collection results were not found.');

    return [...pageGrid.querySelectorAll(':scope > .js-pagination-result')]
      .filter((item) => item.querySelector('product-card'))
      .map((item) => item.cloneNode(true));
  };

  const fetchInParallel = async (urls, limit = 4) => {
    const pages = new Array(urls.length);
    let nextIndex = 0;
    const worker = async () => {
      while (nextIndex < urls.length) {
        const index = nextIndex++;
        pages[index] = await fetchPageProducts(urls[index]);
      }
    };
    await Promise.all(Array.from({ length: Math.min(limit, urls.length) }, worker));
    return pages.flat();
  };

  const start = async () => {
    const loader = document.querySelector('custom-pagination[data-birthday-sale-loader="true"]');
    if (!loader || hasActiveFiltersOrSort() || loader.dataset.birthdaySaleLoaded === 'true') return;

    const results = loader.querySelector('#filter-results');
    const grid = results?.querySelector('ul');
    const pagination = loader.querySelector('.js-pagination');
    if (!results || !grid) return;

    loader.dataset.pauseInfiniteScroll = 'true';
    loader.dataset.birthdaySaleLoaded = 'true';
    if (pagination) pagination.hidden = true;

    try {
      // Show the first page in sale-first order immediately, then retrieve the
      // remaining pages in parallel rather than waiting for a serial chain.
      sortSaleProducts(grid);

      const totalPages = Number(loader.dataset.birthdaySalePages || 1);
      const currentUrl = new URL(window.location.href);
      const currentPage = Number(currentUrl.searchParams.get('page') || 1);
      const urls = Array.from({ length: totalPages }, (_, index) => index + 1)
        .filter((page) => page !== currentPage)
        .map((page) => {
          const url = new URL(currentUrl);
          url.searchParams.set('page', String(page));
          return url.href;
        });
      const remainingProducts = await fetchInParallel(urls);
      remainingProducts.forEach((item) => grid.append(item));
      sortSaleProducts(grid);

      window.initLazyImages?.();
      pagination?.remove();
    } catch (error) {
      console.warn('Birthday Sale collection ordering could not finish.', error);
      if (pagination) pagination.hidden = false;
      loader.dataset.pauseInfiniteScroll = 'false';
    }
  };

  document.addEventListener('DOMContentLoaded', start);
})();
